import { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineBook, AiOutlineFile, AiOutlineFolder } from "react-icons/ai";
import { useHistory, useParams } from "react-router-dom";
import UsuarioContext from "../../../../../context/userContext/context";
import { ButtonFavorite } from "../../../../components/button-favorite";
import { FlatCardObject } from "../../../../components/flat-card-object";

import { IMaterial } from "../../../../models/IMaterial";

import { IObjectResponse } from "../../../../models/IObjectResponse";
import { detailItem } from "../../../../services/item.service";
import { Objects } from "../../home/styles";

import { LimitCharacterDiv } from "../../media/media-details/styles";
import { CardBody, CardDescription, CardTitle } from "../../styled";
import { ButtonGoBack } from "../../components/button-go-back";
import { colors } from "../../../../../theme/theme";

export const UnityDetails = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const { id } = useParams<{ id: string }>();
	const { user } = useContext(UsuarioContext);

	const [loading, setLoading] = useState(true);
	const [material, setMaterial] = useState<IMaterial>();

	const redirectDiscipline = () => {
		history.push(`/disciplines/${material?.discipline_id}`);
	};

	useEffect(() => {
		if (id) {
			detailItem(id).then((resp) => {
				setMaterial(resp);
				setLoading(false);
			});
		}
	}, [id]);

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner animation="border" variant="primary" />
			</div>
		);
	}

	return (
		<Container fluid>
			<CardTitle color={colors.mainColors.verde_dstore}>
				<Row>
					<Col xs={10} lg={11} className="d-flex align-items-center">
						<ButtonGoBack />
						{material?.title}
					</Col>
					<Col xs={2} lg={1} className="text-center">
						{user.token && (
							<ButtonFavorite
								material={material}
								isMaterialView={false}
								variant="white"
							/>
						)}
					</Col>
				</Row>
			</CardTitle>
			<CardBody>
				<Row className="mt-3">
					<Col>
						<CardDescription>
							<Row>
								<Col lg={2}>
									<LimitCharacterDiv className="mb-3">
										<b>{translation("material.code")}: </b>{" "}
										{material?.code ||
											translation(
												"userAccount.uninformed"
											)}
									</LimitCharacterDiv>
								</Col>
								<Col>
									<LimitCharacterDiv>
										<b>
											{translation("material.discipline")}
											:{" "}
										</b>{" "}
										<div
											style={{
												display: "inline-block",
												cursor: "pointer",
												color: "#6473FF",
											}}
											onClick={redirectDiscipline}
										>
											{material?.discipline}{" "}
										</div>
									</LimitCharacterDiv>
								</Col>
								<Col>
									<LimitCharacterDiv>
										<b>
											{translation(
												"components.card-news.knowledge"
											)}
											:{" "}
										</b>{" "}
										{!!material?.knowledge_area
											? material.knowledge_area.length > 1
												? material.knowledge_area[0]
														?.description + " +"
												: material.knowledge_area[0]
														?.description
											: translation(
													"userAccount.uninformed"
											  )}
									</LimitCharacterDiv>
								</Col>
								<Col>
									<LimitCharacterDiv>
										<b>
											{translation(
												"components.card-news.Deadline"
											)}
											:{" "}
										</b>{" "}
										{material?.deadline
											? material.deadline > 1
												? "20 Dias"
												: "Pronta Entrega"
											: translation(
													"userAccount.uninformed"
											  )}
									</LimitCharacterDiv>
								</Col>
							</Row>
						</CardDescription>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-2">
								<AiOutlineFile
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineFile>{" "}
								{translation("material.menu")}
							</div>

							<div
								dangerouslySetInnerHTML={{
									__html:
										material?.description ||
										translation("userAccount.uninformed"),
								}}
							></div>
						</CardDescription>
					</Col>
				</Row>
				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-3">
								<AiOutlineFolder
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineFolder>{" "}
								{translation("material.medias")}
							</div>
							<Objects>
								{!!material?.medias &&
									material?.medias.map(
										(
											arrayMedias: IObjectResponse,
											index
										) => (
											<div key={index}>
												<FlatCardObject
													detailsMode
													object={arrayMedias}
												/>
											</div>
										)
									)}
								{material?.medias?.length === 0 ? (
									<h6>{translation("notFound.unity")}</h6>
								) : (
									<></>
								)}
							</Objects>
						</CardDescription>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-3">
								<AiOutlineBook
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineBook>{" "}
								{translation("material.bibliography")}
							</div>
							<div
								dangerouslySetInnerHTML={{
									__html:
										material?.reference ||
										translation("userAccount.uninformed"),
								}}
							></div>
						</CardDescription>
					</Col>
				</Row>
			</CardBody>
		</Container>
	);
};
